import React from "react"
import { useTranslation } from "gatsby-plugin-react-i18next"
import Menu from "@mui/material/Menu"
import PricesButtonGroup from "@components/PricesButtonGroup"

export const FiltersMobile = ({
  currencyButtonGroup,
  tableDatesButtonGroup,
  mobileMenuAnchorEl,
  mobileMenuOpen,
  onMobileMenuClose,
  localStoragePrefix,
}) => {
  const { t } = useTranslation()

  return (
    <div
      className={`flex items-right overflow-x-scroll hide-scrollbar justify-end mt-[16px]
					md:overflow-x-visible  min-w-[100%]`}
    >
      <Menu
        elevation={0}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        MenuListProps={{
          "aria-labelledby": "demo-customized-button",
        }}
        anchorEl={mobileMenuAnchorEl}
        open={mobileMenuOpen}
        onClose={onMobileMenuClose}
      >
        <div className="flex justify-between flex-col min-w-[100%] min-h-max p-3">
          <div className={""}>
            <div className={`text-[#5B5866] text-xs m-[2px]`}>
              {t("filter_tit_Currency")}
            </div>
            <PricesButtonGroup
              elements={currencyButtonGroup}
              flexHeight={true}
              groupId="currencyGroup"
              localStoragePrefix={localStoragePrefix}
            />
          </div>
          <div className={"max-w-[180px]"}>
            <div className={`text-[#5B5866] text-xs m-[2px]`}>
              {t("filter_tit_Range")}
            </div>
            <PricesButtonGroup
              elements={tableDatesButtonGroup}
              flexHeight={true}
              groupId="rangeGroup"
              localStoragePrefix={localStoragePrefix}
            />
          </div>
        </div>
      </Menu>
    </div>
  )
}
